// Trial de 30 días a nivel de app (SCRUM-53).

// Días enteros que quedan de trial, redondeando hacia arriba (el último día parcial
// cuenta como 1). null = sin trial o ya expirado.
export function trialDaysLeft(trialEndsAt, now = new Date()) {
  if (!trialEndsAt) return null;
  const ends = new Date(trialEndsAt);
  if (Number.isNaN(ends.getTime())) return null;
  const ms = ends.getTime() - now.getTime();
  if (ms <= 0) return null;
  return Math.ceil(ms / 86400000);
}

// El banner de conversión solo avisa cuando la cosa urge (umbral del ticket: ≤7 días).
export function shouldShowTrialBanner(trialEndsAt, now = new Date()) {
  const days = trialDaysLeft(trialEndsAt, now);
  return days !== null && days <= 7;
}

// SCRUM-54: hubo prueba y ya venció. Sin trial o fecha inválida = false — en ese caso
// el bloqueo es el genérico de activación, no el de "tu prueba terminó".
export function trialHasExpired(trialEndsAt, now = new Date()) {
  if (!trialEndsAt) return false;
  const ends = new Date(trialEndsAt);
  if (Number.isNaN(ends.getTime())) return false;
  return ends.getTime() <= now.getTime();
}
